export default {
	cookie: {
		title: 'Cookies help us provide our service.',
		text: 'The party responsible for data processing is your property management company. Please contact them for information about data processing. This site only generates technically necessary cookies. Your consent for the processing of other cookies, such as for audience measurement, is therefore not required. By clicking “Okay”, you merely acknowledge these notices and do not consent to the use of other cookies.',
	},
}
